"use client";

import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { detectAndSaveGeoPosition } from "@/utils/geolocation";

const UseMyLocationButton = () => {
  const [hasLocation, setHasLocation] = useState(false);
  const handleUseMyLocation = async () => {
    const geo = await detectAndSaveGeoPosition(true); // ✅ only triggers after click

    if (!geo) return;

    const updated = {
      locationType: "current",
      miles: 20,
      latitude: geo.lat,
      longitude: geo.lng,
      isValid: true,
      message: "20 miles from your current location",
    };

    localStorage.setItem("location_filter", JSON.stringify(updated));
    //    window.location.reload();
  };

  return (
    <Button
      variant="outlined"
      onClick={handleUseMyLocation} // ✅ only triggered by user
      sx={{ mt: 2 }}
    >
      Use My Location
    </Button>
  );
};

export default UseMyLocationButton;
